import PropTypes from "prop-types";

import { Mention } from "pages/[tenant]/g/components/Feed/components/Mention";

interface IRenderStringHtmlProps
  extends React.DetailedHTMLProps<
    React.HTMLAttributes<HTMLSpanElement>,
    HTMLSpanElement
  > {
  value: string;
}

const RenderStringHtml = ({
  value,
  className,
  style,
  ...props
}: IRenderStringHtmlProps) => {
  if (value?.includes("data-denotation-char"))
    return <Mention className={className} style={style} value={value} />;

  return (
    <span
      data-testid="render-string-html"
      dangerouslySetInnerHTML={{ __html: value }}
      style={{ ...style }}
      className={className}
      {...props}
    />
  );
};

RenderStringHtml.defaultProps = {
  value: "",
  className: "",
  style: {},
};

RenderStringHtml.propTypes = {
  value: PropTypes.string,
  className: PropTypes.string,
  style: PropTypes.any,
};

export default RenderStringHtml;
